import * as React from 'react';
import { useSelector } from 'react-redux';

import { UserCardImages } from '../../components/UserCard/UserCardImages';
import { chatImagesSelector } from '../../selectors/chatImagesSelector';
import { UserCardImageContainer } from '../UserCardImageContainer';

export const UserCardImagesContainer: React.VFC = () => {
  const images = useSelector(chatImagesSelector);

  const imagesNode = React.useMemo(
    () =>
      images && images.files?.length
        ? images.files.map(image => <UserCardImageContainer image={image} key={image.uid} />)
        : null,
    [images],
  );

  if (!images || !imagesNode) {
    return null;
  }

  return <UserCardImages images={imagesNode} />;
};
